import { type Chart } from "chart.js";
import { format } from "date-fns";

import { getDateOnly } from "@utils/datetime";

import { type AnnotationData } from "./annotation-plugin-helpers";

const ANNOTATION_TOOLTIP_ID = "chartjs-annotation-tooltip";

const getOrCreateTooltip = () => {
  let tooltipEl = document.getElementById(ANNOTATION_TOOLTIP_ID);

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = ANNOTATION_TOOLTIP_ID;
    document.body.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const setTooltipPosition = (
  chart: Chart,
  data: AnnotationData,
  tooltipEl: HTMLElement,
) => {
  const { top, left } = chart.canvas.getBoundingClientRect();
  const xPosition = data.xPosition ?? data.point.x;
  tooltipEl.style.opacity = "1";
  tooltipEl.style.transform = `translate(
    -${tooltipEl.offsetWidth / 2}px,
    -${tooltipEl.offsetHeight}px
  )`;
  tooltipEl.style.left = left + xPosition + "px";
  const xAxisScales = chart.boxes.filter(({ axis }: any) => axis === "x");
  const xAxisScalesPadding = xAxisScales.map(
    ({ options }: any) => options.ticks.padding,
  );
  const xAxisPaddingFromChartTop = Math.max(...xAxisScalesPadding, 0);
  // 36 is the height of the icon
  tooltipEl.style.top =
    top + chart.height - 40 - xAxisPaddingFromChartTop + "px";
};

export const addAnnotationTooltip = (chart: Chart, data: AnnotationData) => {
  const tooltipEl = getOrCreateTooltip();
  const { point } = data;
  const date = (point as any).$context.raw?.date;

  if (date) {
    tooltipEl.innerHTML = date ? format(getDateOnly(date), "MMM d") : "";
    setTooltipPosition(chart, data, tooltipEl);
  }
};

export const showAnnotationsTooltip = (chart: Chart, data: AnnotationData) => {
  const tooltipEl = getOrCreateTooltip();
  const { clusteredDates } = data;

  if (clusteredDates) {
    tooltipEl.innerHTML = clusteredDates
      .map(
        (date, index) =>
          `<div
            class="${
              index + 1 === clusteredDates.length ? "" : "mb-1"
            } font-bold"
          >
            ${format(getDateOnly(date), "MMM d")}
          </div>`,
      )
      .join("");
    setTooltipPosition(chart, data, tooltipEl);
  }
};

export const removeAnnotationTooltip = () => {
  const tooltipEl = document.getElementById(ANNOTATION_TOOLTIP_ID);
  if (tooltipEl) {
    tooltipEl.style.opacity = "0";
  }
};
